import React from 'react';
import { Button } from './ui/button';

const HeroSection = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen max-h-[900px] flex flex-col overflow-hidden">
      {/* Background Image - Fixed, no zoom, stable framing */}
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_divonne-dining/artifacts/8lydfra6_grok-image-596355c8-748c-45bb-bc6f-4315a7d3ea05.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'scroll'
        }}
      >
        {/* Light dark overlay */}
        <div className="absolute inset-0 bg-black/30"></div>
      </div>

      {/* CSS Animations */}
      <style>{`
        /* Smooth fade-in */
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .fade-in {
          animation: fadeIn 1.2s ease-out forwards;
          opacity: 0;
        }
        
        .fade-in-delay-1 { animation-delay: 0.2s; }
        .fade-in-delay-2 { animation-delay: 0.5s; }
        .fade-in-delay-3 { animation-delay: 0.8s; }
      `}</style>

      {/* Content - Upper signature block */}
      <div className="relative z-10 flex-1 flex flex-col items-center text-white px-6">
        
        {/* Spacer for navigation */}
        <div className="h-40 md:h-48 lg:h-56"></div>
        
        {/* ===== SIGNATURE BLOCK - Upper zone ===== */}
        <div className="text-center fade-in">
          {/* Wax Seal Logo */}
          <div className="mb-6 md:mb-8">
            <img
              src="https://customer-assets.emergentagent.com/job_divonne-dining/artifacts/m1azxgvy_Sceau%20en%20cire%20Rouge.png"
              alt="La Rotonde"
              className="mx-auto w-30 md:w-40 lg:w-48 h-auto"
              style={{ filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.3))' }}
            />
          </div>
          
          {/* Brand Name - LA ROTONDE */}
          <h2 
            className="fade-in fade-in-delay-1 uppercase"
            style={{ 
              fontFamily: "var(--font-display)",
              fontWeight: '400',
              color: '#FFFFFF',
              fontSize: 'clamp(34px, 6vw, 72px)',
              letterSpacing: '0.12em',
              textShadow: '2px 2px 4px rgba(0,0,0,0.4)'
            }}
          >
            LA ROTONDE
          </h2>
          
          {/* Tagline - Just below LA ROTONDE */}
          <h1 
            className="mt-4 md:mt-6 leading-relaxed uppercase max-w-3xl mx-auto fade-in fade-in-delay-2"
            style={{ 
              fontFamily: "var(--font-display)", 
              fontWeight: '400',
              color: '#FFFFFF',
              fontSize: 'clamp(16px, 2.5vw, 22px)',
              letterSpacing: '0.08em',
              textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
            }}
          >
            Une nouvelle table à Divonne-les-Bains
          </h1>
        </div>
        
        {/* ===== SPACER - Push chef name to bottom ===== */}
        <div className="flex-1"></div>
        
        {/* ===== Chef Name - Above flowers ===== */}
        <div className="text-center mb-4 md:mb-6 fade-in fade-in-delay-2">
          <p 
            className="italic"
            style={{ 
              fontFamily: "var(--font-display)", 
              fontWeight: '400',
              fontStyle: 'italic',
              color: '#FFFFFF',
              opacity: '0.95',
              fontSize: 'clamp(20px, 2.2vw, 26px)',
              letterSpacing: '0.055em',
              textShadow: '1px 1px 2px rgba(0,0,0,0.4)'
            }}
          >
            Une cuisine signée par le chef Pascal Aguettaz
          </p>
        </div>

        {/* ===== CTA Buttons ===== */}
        <div className="flex flex-col sm:flex-row gap-4 md:gap-5 justify-center mb-12 md:mb-16 fade-in fade-in-delay-3">
          <Button
            onClick={() => scrollToSection('reservation')}
            className="bg-white text-gray-900 hover:bg-gray-100 px-10 py-6 text-base tracking-wide transition-all duration-300 hover:-translate-y-1 shadow-lg"
            style={{ fontFamily: "var(--font-body)" }}
            data-testid="hero-reserve-btn"
          >
            Réserver une table
          </Button>
          <Button
            onClick={() => scrollToSection('menu')}
            variant="outline"
            className="border-2 border-white text-white bg-transparent hover:bg-white hover:text-gray-900 px-10 py-6 text-base tracking-wide transition-all duration-300 hover:-translate-y-1"
            style={{ fontFamily: "var(--font-body)" }}
            data-testid="hero-menu-btn"
          >
            Voir la carte
          </Button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 animate-bounce z-10">
        <div className="w-5 h-9 border-2 border-white/50 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
